import {attachMessages} from "../../components/survey/messages";
import execute_on from "../../libs/execute-on";
import {attachFroalaEditor} from "../../plugins/froala-editor";

execute_on('survey.calibration.edit', function () {
    $([
        '#motor_instruction_messages',
        '#motor_short_instruction_message',
        '#reading_speed_instruction_messages',
        '#reading_speed_short_instruction_message',
        '#control_screen_question_message',
        '#control_screen_wrong_answer_messages',
    ]).each(function () {
        attachMessages($(this));
    });
    attachFroalaEditor();
});
